"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _constants = require("../constants");

var _IdentityProviderDefa;

var IdentityProviderDefaults = (_IdentityProviderDefa = {}, (0, _defineProperty2.default)(_IdentityProviderDefa, _constants.USER_ID, 0), (0, _defineProperty2.default)(_IdentityProviderDefa, _constants.PORTAL_ID, 0), (0, _defineProperty2.default)(_IdentityProviderDefa, _constants.CREATED_AT, 0), (0, _defineProperty2.default)(_IdentityProviderDefa, _constants.CREATED_BY, 0), _IdentityProviderDefa);

var UserExemption =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(UserExemption, _Record);

  function UserExemption() {
    (0, _classCallCheck2.default)(this, UserExemption);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UserExemption).apply(this, arguments));
  }

  return UserExemption;
}((0, _immutable.Record)(IdentityProviderDefaults, _constants.USER_EXEMPTION));

exports.default = UserExemption;
module.exports = exports.default;